import { createContext, Dispatch } from 'react'
import { DndState, initialDndState } from '../utils/dnd.utils'
import { DnDAction } from '../reducers/DragNDrop.reducer'

export const DragNDropContext = createContext<{
  state: DndState
  dispatch: Dispatch<DnDAction>
}>({ state: initialDndState, dispatch: () => {} })
